<template>
    <div class="field">
        <label v-if="label">Theme</label><br/>

        <div @click="$emit('input', 'dark')" class="theme dark active">
            <div v-if="value === 'dark'" class="icon fa fa-check"></div>
        </div>

        <div @click="$emit('input', 'green')" class="theme green">
            <div v-if="value === 'green'" class="icon fa fa-check"></div>
        </div>

        <div @click="$emit('input', 'blue')" class="theme blue">
            <div v-if="value === 'blue'" class="icon fa fa-check"></div>
        </div>

        <div class="is-clearfix"></div>
    </div>
</template>

<script>
export default {
    name: 'SpaceThemePicker',
    props: { value: String, label: { type: Boolean, default: true } },
};
</script>

<style scoped>
    .theme {
        width: 5rem;
        float: left;
        height: 1.7rem;
        margin: 0.15rem;
        border-radius: 3px;
        color: white;
        cursor: pointer;
    }
    .dark {background: #37474F;}
    .green {background: #24573a;}
    .blue {background: #1f2768;}
</style>
